/**
 *
 * FeatureWithIcon
 *
 */

import React from 'react';
import { SDiv, SText } from './styles';
import Icon from '../Icon';
import PropTypes from 'prop-types';

/* 

FeatureWithIcon can be used with SVG icon picture or with react-icons

if isIconSVG is false, icon === <ReactIcon />
if isIconSVG is true, icon === 'star' (all variants can be found in Icon Component)

*/
const FeatureWithIcon = ({ text, icon, withBackground, isIconSVG }) => {
  return (
    <SDiv>
      {isIconSVG && (
        <Icon
          icon={icon}
          withBackground={withBackground}
          width={24}
          height={24}
        />
      )}

      <SText isIconSVG={isIconSVG} className="lead">
        {!isIconSVG && icon}
        {text}
      </SText>
    </SDiv>
  );
};

FeatureWithIcon.propTypes = {
  icon: PropTypes.any,
  text: PropTypes.string,
  withBackground: PropTypes.bool,
  isIconSVG: PropTypes.bool,
};

export default FeatureWithIcon;
